"use client";

import { cn, useTimer } from "@cloai/uikit";
import dayjs from "dayjs";
import { useTranslations } from "next-intl";

const STYLES = {
  base: cn(
    "relative flex w-fit gap-1 rounded-sm px-1 py-0.5 opacity-0 transition-opacity duration-500",
    "md:px-1.5 md:py-1",
  ),
  active: "opacity-100",
  variant: {
    orange: cn("bg-body text-primary"),
    white: cn("bg-body text-white"),
    pink: cn("bg-gradient-to-r from-pink-300 to-pink-500 text-white"),
  },
  number: cn(
    "flex min-w-7 items-end justify-center gap-0.5 text-[clamp(0.75rem,min(4vw,4vh),1.125rem)] leading-4 font-bold",
  ),
  word: cn("text-xs leading-none text-white"),
  colon: cn("text-sm/4 text-white"),
};

type TTimerProps = {
  endsAt: Date;
  theme?: "orange" | "white" | "pink";
};

export const Timer = ({ endsAt, theme = "orange" }: TTimerProps) => {
  const n = useTranslations("TimerForOffer");

  const end = endsAt || dayjs().endOf("day").format();
  const timer = useTimer(end);

  return (
    <div
      className={cn(
        STYLES.base,
        STYLES.variant[theme],
        timer?.formattedSeconds && STYLES.active,
      )}
    >
      <div className={STYLES.number}>
        {timer?.formattedDays} <span className={STYLES.word}>{n("days")}</span>
      </div>

      <div className={STYLES.colon}>:</div>

      <div className={STYLES.number}>
        {timer?.formattedHours}{" "}
        <span className={STYLES.word}>{n("hours")}</span>
      </div>

      <div className={STYLES.colon}>:</div>

      <div className={STYLES.number}>
        {timer?.formattedMinutes}{" "}
        <span className={STYLES.word}>{n("minutes")}</span>
      </div>

      <div className={STYLES.colon}>:</div>

      <div className={STYLES.number}>
        {timer?.formattedSeconds}{" "}
        <span className={STYLES.word}>{n("seconds")}</span>
      </div>
    </div>
  );
};
